<p-tabView [(activeIndex)]="activeIndex">
    <p-tabPanel header="Accompagnatori">
        <div class="mt-4">
            <p-table [value]="companions" [paginator]="true" [rows]="5" [lazy]="true"
                (onLazyLoad)="getCompanions($event)" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali" #dt1
                [(selection)]="selected" dataKey="id">
                <ng-template pTemplate="header">
                    <tr>
                        <th></th>
                        <th>Nome</th>
                        <th>Email</th>
                        <th>Presentazione</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-c>
                    <tr>
                        <td>
                            <p-tableRadioButton [value]="c" />
                        </td>
                        <td>
                            <div class="flex align-items-center gap-2">
                                <p-avatar [image]="c.profile_picture | imagePipe: 'user':'sm'" shape="circle"></p-avatar>
                                {{c.name}} {{c.last_name}}
                            </div>
                        </td>
                        <td>{{c.email || '-'}}</td>
                        <td [innerHTML]="c.description"></td>
                        <td>
                            @if(c.created_by_user.id === auth.getUserId()){
                            <div class="flex">
                                <p-button icon="pi pi-trash" [text]="true" size="small"
                                    (click)="confirmDelete(c.id)"></p-button>
                                <p-button icon="pi pi-pencil" [text]="true" size="small"
                                    (click)="updateCompanion(c.id)"></p-button>
                            </div>
                            }

                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="modal-footer flex justify-content-between">
            <div class="w-full">
                <p-button label="Annulla" size="small" (click)="close()" [outlined]="true"></p-button>
            </div>
            <div class="w-full ml-3">
                <p-button label="Scegli" size="small" (click)="saveCompanion()" styleClass="slide-o"></p-button>
            </div>
        </div>
    </p-tabPanel>

    <p-tabPanel header="Crea accompagnatore">
        <div class="mt-4">
            <form [formGroup]="frm">
                <div class="grid">
                    <div class="col-12 md:col-4">
                        <label>Nome</label>
                        <div class="mt-1">
                            <input type="text" pInputText class="w-full" formControlName="name">
                            @if(frm.get('name')?.errors && frm.get('name')?.dirty){
                            <st-errors [errors]="frm.get('name')?.errors"></st-errors>
                            }
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <label>Cognome</label>
                        <div class="mt-1">
                            <input type="text" pInputText class="w-full" formControlName="last_name">
                            @if(frm.get('last_name')?.errors && frm.get('last_name')?.dirty){
                            <st-errors [errors]="frm.get('last_name')?.errors"></st-errors>
                            }
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <label>Email</label>
                        <div class="mt-1">
                            <input type="text" pInputText class="w-full" formControlName="email">
                        </div>
                    </div>
                    <div class="col-12">
                        <label>Presentazione</label>
                        <div class="mt-1">
                            <p-editor [style]="{ height: '120px' }" formControlName="description">
                                <ng-template pTemplate="header">
                                    <span class="ql-formats">
                                        <button type="button" class="ql-bold" aria-label="Bold"></button>
                                        <button type="button" class="ql-italic" aria-label="Italic"></button>
                                        <button type="button" class="ql-underline" aria-label="Underline"></button>
                                    </span>
                                </ng-template>
                            </p-editor>
                        </div>
                    </div>

                    <input type="file" (change)="fileChangeEvent($event)" id="image" style="display: none;" />
                    <div class="mx-auto mt-3">
                        <label for="image" class="label block">
                            Scegli un'immagine
                        </label>
                    </div>

                    @if(img){
                    <div class="col-6">
                        <img class="w-full" [src]="img | imagePipe:'user':'lg'" />
                    </div>
                    }

                    <div class="mt-3">
                        <div class="grid">
                            <div class="col-6">
                                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                                    [aspectRatio]="1" format="png" (imageCropped)="imageCropped($event)"
                                    (imageLoaded)="imageLoaded($event)" (cropperReady)="cropperReady()"
                                    (loadImageFailed)="loadImageFailed()"></image-cropper>
                            </div>
                            <div class="col-6">
                                <img class="w-full" [src]="croppedImage" />
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </div>
        <div class="modal-footer flex justify-content-between">
            <div class="w-full">
                <p-button label="Annulla" size="small" (click)="close()" [outlined]="true"></p-button>
            </div>
            <div class="w-full ml-3">
                <p-button label="Scegli" size="small" (click)="saveNew()" styleClass="slide-o"></p-button>
            </div>
        </div>
    </p-tabPanel>
</p-tabView>